module.exports = __webpack_public_path__ + "img/case2_2.2b5d6a3c.png";